export default __webpack_public_path__ + "static/media/in-progress.4dea078e.png";